import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-preview"
export default class extends Controller {
  static targets = ["previewWrapper", "imagePreview"]

  previewImage(event) {
    const input = event.target

    const file = input.files[0]
    const reader = new FileReader()

    reader.onload = (e) => {
      const imagePreview = this.imagePreviewTarget
      imagePreview.src = e.target.result
      this.previewWrapperTarget.classList.remove('hidden')
    }

    if (file) {
      reader.readAsDataURL(file)
    }
  }
}
